import { useEffect, useState } from "react";
import { _BudgetObligationFactory, _single } from "../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { BasicTable, MASK_MONEY } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import { ListMenu } from "../../theme/Component/ListMenu";
import { Singleton } from "../../../core/services/Singleton";
import { PrintJson } from "../../theme/Component/PrintJson";
import { InputMoney } from "../../theme/Input/InputMoney";
import { BasicMultiSelectTable } from "../../theme/Component/BasicMultiSelecTable";

interface Props {
    formData: any;
    onChange: Function;
}


export const RegisterObligation = ({ formData, onChange }: Props) => {

    const { lista, setLista, instance, bean, setBean } = useDataBean(_BudgetObligationFactory);
    const single = Singleton.getInstance();

    const [initBean, setInitBean] = useState<any>({});
    const [selectRP, setSelectRP] = useState<any>({});

    const [budgetList, setBudgetlist] = useState<any>([]);
    const [listaResult, setListaResult] = useState<any>([]);

    const [modalSelect, setModalSelect] = useState<any>({ name: 'Seleccionar Registro Presupuestal', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalEdit, setModalEdit] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });

    const getLista = (document) => {
        instance.getRPBudgetForObligation(document.IDDocument, document.DocumentDate)
            .then((resp) => {
                setBudgetlist(resp)
            })
            .catch((err) => {
                toast.error(err);
            });
    };


    const createBudgetOB = (document) => {
        instance.createObligationBudgetRow(
            formData.RegisterDate, 
            document.RPIDDocument, 
            document.RPDocumentDate, 
            document.IDBudgetType, 
            document.BudgetIDStr, 
            document.IDBudgetSource, 
            document.IDBudgetResource, 
            document.Value ?? document.LeftValue, 
            document.Description
        ).then((resp) => {
            setLista(prevLista => {
                // Verificar si ya existe un objeto con las mismas propiedades
                const index = prevLista.findIndex(item =>
                    item.DataBeanProperties.RPIDDocument === resp.RPIDDocument &&
                    item.DataBeanProperties.BudgetIDStr === resp.BudgetIDStr &&
                    item.DataBeanProperties.IDBudgetResource === resp.IDBudgetResource &&
                    item.DataBeanProperties.IDBudgetSource === resp.IDBudgetSource
                );
    
                let updatedLista;
                if (index !== -1) {
                    // Si existe, lo reemplaza
                    updatedLista = [...prevLista];
                    updatedLista[index] = { DataBeanProperties: resp, DataBeanName: 'budget.Budget' };
                } else {
                    // Si no existe, lo agrega
                    updatedLista = [...prevLista, { DataBeanProperties: resp, DataBeanName: 'budget.Budget' }];
                }
    
                return updatedLista;
            });
    
            setBean({});
            setInitBean({});
            setModal({ ...modal, "view": false });
        }).catch((err) => {
            toast.error(err);
        });
    };
    

    useEffect(() => {
        if (lista.length > 0) {
            onChange(lista)
        }
    }, [lista])

    const head = [
        { title: 'Rubro Presupuestal', property: 'BudgetName', visible: true },
        { title: 'Recurso Presupuestal', property: 'BudgetResourceName', visible: true },
        { title: 'Fuente de Recursos', property: 'BudgetSourceName', visible: true },
        { title: 'Vr Compromiso', property: 'RPValue', visible: true, mask: MASK_MONEY },
        { title: 'Vr Obligado', property: 'OBValue', visible: true, mask: MASK_MONEY },
        { title: 'Saldo x Obligar', property: 'LeftValue', visible: true, mask: MASK_MONEY },
        { title: 'Valor a Obligar', property: 'Value', visible: true, mask: MASK_MONEY },
        { title: 'Observaciones', property: 'Description', visible: true },
    ]

    const headSelect = [
        { title: 'Registro Presupuestal', property: 'RPConsecutive', visible: true },
        { title: 'Rubro Presupuestal', property: 'BudgetName', visible: true },
        { title: 'Recurso Presupuestal', property: 'BudgetResourceName', visible: true },
        { title: 'Fuente de Recursos', property: 'BudgetSourceName', visible: true },
        { title: 'Vr Compromiso', property: 'RPValue', visible: true, mask: MASK_MONEY },
        { title: 'Vr Obligado', property: 'OBValue', visible: true, mask: MASK_MONEY },
        { title: 'Saldo x Obligar', property: 'LeftValue', visible: true, mask: MASK_MONEY },
    ]

    const addItem = () => {
        setModalSelect({ ...modalSelect, "view": true });
        setListaResult([]);
        setBudgetlist([]);
        setSelectRP({});
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: () => { addItem() } }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-line', visible: single.canEdit(), evento: () => { setModalEdit({ ...modalEdit, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { eliminarItem() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const eliminarItem = () => {
        const updatedLista = lista.filter((bRow: any) =>
            JSON.stringify(bRow.DataBeanProperties) !== JSON.stringify(bean)
        );

        setBean({});
        setInitBean({})
        setLista(updatedLista);
    }

    const setRowBean = (objeto: any) => {
        setBean(objeto);
        setInitBean(objeto);
    }

    useEffect(() => { getLista(selectRP) }, [selectRP]);

    const updateItem = () => {

        const updatedLista = lista.filter((item: any) =>
            JSON.stringify(item.DataBeanProperties) !== JSON.stringify(initBean)
        );

        let temp = [...updatedLista, {
            DataBeanProperties: bean,
            DataBeanName: 'budget.Budget'
        }];

        setLista(temp);
        setBean({});
        setInitBean({});
        setModalEdit({ ...modalEdit, "view": false })
    }

    return (
        <div className="row">
            <div className="col">
                <BasicTable listButtons={listaBotones()} head={head} body={lista} rowSet={(e) => { setRowBean(e) }} iconButtons={iconButtonsItem} />
            </div>

            <div className="col-md-12">
                <Modal modal={modalSelect} updateModal={setModalSelect} eventModal={() => { setModalSelect({ ...modalSelect, "view": false }); setModal({ ...modal, "view": true, "name": "Valores a Obligar" }) }}>
                    <div className="row">
                        <div className="col-md-12">
                            <select
                                className="form-control"
                                onChange={(e) => {
                                    const selectedIndex = e.target.value;
                                    const selectedObject = formData.RPList[selectedIndex];
                                    setSelectRP(selectedObject?.DataBeanProperties);
                                }}
                            >
                                <option value="">...</option>
                                {formData.RPList.map((item: any, index: number) => (
                                    <option key={index} value={index}>
                                        {item.DataBeanProperties.Mnemonic} - {item.DataBeanProperties.Consecutive}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="col-md-12">
                            <BasicMultiSelectTable body={budgetList} bodyResult={listaResult} head={headSelect} keyId="BudgetIDStr" updateValues={({ bodyResult }) => {
                                setListaResult(bodyResult)
                            }} />
                        </div>
                    </div>
                </Modal>
            </div>

            <div className="col-md-12">
                <Modal modal={modal} updateModal={setModal} eventModal={() => {
                    listaResult.forEach((item) => {
                        createBudgetOB(item.DataBeanProperties);
                    });
                }}>
                    <div className="row">
                        {listaResult.map((item, index) => (
                            <div key={index} className="col-md-12 mb-3">
                                {/* <PrintJson json={item} /> */}
                                <h6>{item.DataBeanProperties.BudgetName} - Documento: {item.DataBeanProperties.RPIDDocument}</h6>
                                <div className="row">
                                    <div className="col-md-12">
                                        <InputMoney
                                            _label="Valor a Obligar"
                                            _value={item.DataBeanProperties.LeftValue}
                                            onChange={(e) => {
                                                const updatedLista = [...listaResult];
                                                updatedLista[index] = {
                                                    ...updatedLista[index],
                                                    DataBeanProperties: {
                                                        ...updatedLista[index].DataBeanProperties,
                                                        Value: e,
                                                    },
                                                };
                                                setListaResult(updatedLista);
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-12">
                                        <label>Observaciones</label>
                                        <textarea
                                            className="form-control"
                                            value={item.DataBeanProperties.Description || ""}
                                            onChange={(e) => {
                                                const updatedLista = [...listaResult];
                                                updatedLista[index] = {
                                                    ...updatedLista[index],
                                                    DataBeanProperties: {
                                                        ...updatedLista[index].DataBeanProperties,
                                                        Description: e.target.value,
                                                    },
                                                };
                                                setListaResult(updatedLista);
                                            }}
                                        />
                                    </div>
                                </div>
                                {index < listaResult.length - 1 && <hr />}
                            </div>
                        ))}
                    </div>
                </Modal>
            </div>

            <div className="col-md-12">
                <Modal modal={modalEdit} updateModal={setModalEdit} eventModal={updateItem}>
                    <div className="row">
                        <div className="col-md-12">
                            <InputMoney _label="Valor a Obligar" _value={bean.Value} onChange={(e) => { setBean({ ...bean, "Value": e }) }} />
                        </div>
                        <div className="col-md-12">
                            <label>Observaciones</label>
                            <textarea className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, "Description": e.target.value }) }} />
                        </div>
                    </div>
                </Modal>
            </div>
        </div>
    )
}